import { DiscountTypes } from "@/common/enums";

export default class EliteLiveSettingsModel {
    isEnabled: boolean = false;
    endpoint: string = "";
    username: string = "";    
    clientKey: string = "";       
}
